"use client";

import { c as _c } from "react/compiler-runtime";
import { IconPaperPlane2Outline18 } from "nucleo-ui-outline-18";
import UserAvatar from "@/app/(v2)/_components/UserAvatar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Textarea } from "@/components/ui/textarea";
import type { WorkflowComment } from "@/types/workflow-comments";
import { useState } from "react";
interface NodeCommentsBadgeProps {
  nodeComments: WorkflowComment[];
  onAddComment?: (text: string) => void;
}

/**
 * Displays a badge showing comment avatars and count for workflow nodes.
 * Clicking opens a popover with all comments listed and an input to add new comments.
 * Used in ActionNode, LogicNode, and TriggerNode.
 */
export default function NodeCommentsBadge(t0) {
  const $ = _c(55);
  const {
    nodeComments,
    onAddComment
  } = t0;
  const [open, setOpen] = useState(false);
  const [newComment, setNewComment] = useState("");
  if (!nodeComments || nodeComments.length === 0) {
    return null;
  }
  let T0;
  let T1;
  let handleKeyDown;
  let handleSubmit;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[0] !== newComment || $[1] !== nodeComments || $[2] !== onAddComment || $[3] !== open) {
    const uniqueCommenters = nodeComments.map(_temp).filter(_temp2);
    const displayCommenters = uniqueCommenters.slice(-2).reverse();
    let t9;
    if ($[16] !== newComment || $[17] !== onAddComment) {
      t9 = () => {
        if (!newComment.trim() || !onAddComment) {
          return;
        }
        onAddComment(newComment.trim());
        setNewComment("");
      };
      $[16] = newComment;
      $[17] = onAddComment;
      $[18] = t9;
    } else {
      t9 = $[18];
    }
    handleSubmit = t9;
    let t10;
    if ($[19] !== handleSubmit) {
      t10 = e => {
        if (e.key === "Enter" && !e.shiftKey) {
          e.preventDefault();
          handleSubmit();
        }
      };
      $[19] = handleSubmit;
      $[20] = t10;
    } else {
      t10 = $[20];
    }
    handleKeyDown = t10;
    T1 = Popover;
    t7 = open;
    t8 = setOpen;
    T0 = PopoverTrigger;
    t6 = true;
    t3 = "button";
    t4 = _temp3;
    t5 = "border-ds-border-default dark:hover:bg-ds-neutral-800/50 hover:bg-ds-surface-hover flex w-full cursor-pointer items-center gap-2 border-t pt-2 text-left transition-colors";
    t1 = "relative flex";
    t2 = displayCommenters.map((commenter_0, idx) => {
      const isAnonymous = commenter_0.clientId.startsWith("anon_") || commenter_0.clientId.startsWith("client-");
      return <div key={commenter_0.clientId} className="relative" style={{
        marginLeft: idx > 0 ? "-8px" : "0",
        zIndex: displayCommenters.length - idx
      }}><div className="dark:border-ds-neutral-900 rounded-full border-2 border-white"><UserAvatar b3GlobalId={isAnonymous ? undefined : commenter_0.clientId} name={commenter_0.name} isAnonymous={isAnonymous} width={20} height={20} /></div></div>;
    });
    $[0] = newComment;
    $[1] = nodeComments;
    $[2] = onAddComment;
    $[3] = open;
    $[4] = T0;
    $[5] = T1;
    $[6] = handleKeyDown;
    $[7] = handleSubmit;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    T0 = $[4];
    T1 = $[5];
    handleKeyDown = $[6];
    handleSubmit = $[7];
    t1 = $[8];
    t2 = $[9];
    t3 = $[10];
    t4 = $[11];
    t5 = $[12];
    t6 = $[13];
    t7 = $[14];
    t8 = $[15];
  }
  let t9;
  if ($[21] !== t1 || $[22] !== t2) {
    t9 = <div className={t1}>{t2}</div>;
    $[21] = t1;
    $[22] = t2;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  const t10 = nodeComments.length === 1 ? "comment" : "comments";
  let t11;
  if ($[24] !== nodeComments.length || $[25] !== t10) {
    t11 = <span className="text-ds-text-subtle dark:text-ds-text-disabled text-xs">{nodeComments.length} {t10}</span>;
    $[24] = nodeComments.length;
    $[25] = t10;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== t11 || $[28] !== t3 || $[29] !== t4 || $[30] !== t5 || $[31] !== t9) {
    t12 = <button type={t3} onClick={t4} className={t5}>{t9}{t11}</button>;
    $[27] = t11;
    $[28] = t3;
    $[29] = t4;
    $[30] = t5;
    $[31] = t9;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  let t13;
  if ($[33] !== T0 || $[34] !== t12 || $[35] !== t6) {
    t13 = <T0 asChild={t6}>{t12}</T0>;
    $[33] = T0;
    $[34] = t12;
    $[35] = t6;
    $[36] = t13;
  } else {
    t13 = $[36];
  }
  let t14;
  if ($[37] !== nodeComments) {
    t14 = nodeComments.map(_temp5);
    $[37] = nodeComments;
    $[38] = t14;
  } else {
    t14 = $[38];
  }
  let t15;
  if ($[39] !== t14) {
    t15 = <div className="divide-ds-neutral-200 dark:divide-ds-neutral-700 max-h-[250px] divide-y overflow-y-auto">{t14}</div>;
    $[39] = t14;
    $[40] = t15;
  } else {
    t15 = $[40];
  }
  let t16;
  if ($[41] !== handleKeyDown || $[42] !== handleSubmit || $[43] !== newComment || $[44] !== onAddComment) {
    t16 = onAddComment && <div className="border-ds-border-default border-t p-2"><div className="flex gap-2"><Textarea value={newComment} onChange={e_2 => setNewComment(e_2.target.value)} onKeyDown={handleKeyDown} placeholder="Add a comment..." className="border-ds-neutral-300 flex-1 resize-none px-3 py-1.5 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 dark:border-zinc-600" rows={1} /><button onClick={handleSubmit} disabled={!newComment.trim()} className="rounded-md bg-blue-600 px-2.5 py-1.5 text-white transition-colors hover:bg-blue-700 disabled:cursor-not-allowed disabled:opacity-50 dark:bg-blue-500 dark:hover:bg-blue-600"><IconPaperPlane2Outline18 className="h-4 w-4" /></button></div></div>;
    $[41] = handleKeyDown;
    $[42] = handleSubmit;
    $[43] = newComment;
    $[44] = onAddComment;
    $[45] = t16;
  } else {
    t16 = $[45];
  }
  let t17;
  if ($[46] !== t15 || $[47] !== t16) {
    t17 = <PopoverContent className="border-ds-border-default bg-ds-surface-card shadow-ds-elev-2 w-80 border p-0" align="start" side="right" onClick={_temp4}>{t15}{t16}</PopoverContent>;
    $[46] = t15;
    $[47] = t16;
    $[48] = t17;
  } else {
    t17 = $[48];
  }
  let t18;
  if ($[49] !== T1 || $[50] !== t13 || $[51] !== t17 || $[52] !== t7 || $[53] !== t8) {
    t18 = <T1 open={t7} onOpenChange={t8}>{t13}{t17}</T1>;
    $[49] = T1;
    $[50] = t13;
    $[51] = t17;
    $[52] = t7;
    $[53] = t8;
    $[54] = t18;
  } else {
    t18 = $[54];
  }
  return t18;
}
function _temp5(comment_0) {
  const isAnonymous_0 = comment_0.createdBy.clientId.startsWith("anon_") || comment_0.createdBy.clientId.startsWith("client-");
  return <div key={comment_0.id} className="p-3"><div className="mb-1 flex items-center gap-2"><UserAvatar b3GlobalId={isAnonymous_0 ? undefined : comment_0.createdBy.clientId} name={comment_0.createdBy.name} isAnonymous={isAnonymous_0} width={24} height={24} /><span className="body-sm-medium">{comment_0.createdBy.name}</span><span className="label-xs">{new Date(comment_0.createdAt).toLocaleDateString()}</span></div><p className="text-ds-text-secondary text-sm">{comment_0.text}</p></div>;
}
function _temp4(e_1) {
  return e_1.stopPropagation();
}
function _temp3(e_0) {
  return e_0.stopPropagation();
}
function _temp2(commenter, index, self) {
  return index === self.findIndex(c => c.clientId === commenter.clientId);
}
function _temp(comment) {
  return {
    clientId: comment.createdBy.clientId,
    name: comment.createdBy.name
  };
}